import * as tslib_1 from "tslib";
// Core components
import { OnDestroy, OnInit } from "@angular/core";
// Third party components
import { FieldType } from "@ngx-formly/core";
// Custom components
/**
 * Script start
 */
var QrcodeStructureTypeComponent = /** @class */ (function (_super) {
    tslib_1.__extends(QrcodeStructureTypeComponent, _super);
    function QrcodeStructureTypeComponent() {
        var _this = _super.call(this) || this;
        _this.qrcodeData = "";
        return _this;
    }
    /**
     * Init component
     *
     * @since 1.0.0
     */
    QrcodeStructureTypeComponent.prototype.ngOnInit = function () {
        this.qrcodeData = this.field.formControl.value;
    };
    /**
     * Handle component destroy
     *
     * @since 1.0.0
     */
    QrcodeStructureTypeComponent.prototype.ngOnDestroy = function () {
        // Unsubscribe from all subscriptions
        //this.subscriptions.forEach(sub => sub.unsubscribe());
    };
    return QrcodeStructureTypeComponent;
}(FieldType));
export { QrcodeStructureTypeComponent };
